export enum FileUploadType {
  DEFAULT = 'default',
  RE_UPLOAD = 're-upload'
}

export interface FileUploadProps {
  handleAdd: (doc: any) => void;
  handleRemove: () => void;
  label: string;
  type?: FileUploadType;
  reason?: string;
  uploadedFile?: File | null;
  displayFileName?: string;
  className?: string;
  fileCardClassName?: string;
  uploadButtonStyle?: string;
  isDisabled?: boolean;
  hasError?: boolean;
  buttonLabel?: string;
  hideDeleteButton?: boolean;
  fileNameClassName?: string;
  fileSizeClassName?: string;
  hideFileSize?: boolean;
  showFileUploadIcon?: boolean;
  fileUploadStyles?: string;
  onDownload?: (file: File) => void;
  externalError?: string;
  allowReplace?: boolean;
}

export interface EventDocumentUploadProps extends FileUploadProps {
  allowedFileSize: number;
  allowedFileSizeLabel: string;
  allowedDocumentTypes: string[];
  acceptedDocInputTypes: string;
  subText?: string;
  onError: (error: string) => void;
  uploadedFileUrl?: string;
  className?: string;
  iconClassName?: string;
  hideSuccessState?: boolean;
  errorStyles?: string;
  customClassName?: string;
}
